import { render, staticRenderFns } from "./ReportB.vue?vue&type=template&id=3064dfe5&scoped=true&"
import script from "./ReportB.vue?vue&type=script&lang=js&"
export * from "./ReportB.vue?vue&type=script&lang=js&"
import style0 from "./ReportB.vue?vue&type=style&index=0&id=3064dfe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064dfe5",
  null
  
)

export default component.exports